import { Grid, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { IncomingEnvelop } from "../../../../assets/icons";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const PendingIncomingMailLink = ({
  customSummary,
  loading,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const mailInboxAuth = currentUserAuthorizations?.allowedMailInboxes?.flatMap(
    (allowedMailInbox) => allowedMailInbox.value
  );

  const hasAccessToIncoming =
    (mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming) ||
      mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming) ||
      mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanReadIncoming)) ??
    false;

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "5px",
        width: "100%",
      }}
    >
      {loading ? (
        <Skeleton
          variant="rounded"
          width={"70%"}
          style={{ marginBottom: "2px" }}
        />
      ) : (
        hasAccessToIncoming &&
        !!customSummary?.pendingIncoming &&
        customSummary.pendingIncoming > 0 && (
          <Grid
            style={{
              display: "flex",
              color: theme.palette.primary.main,
              justifyContent: "left",
              alignItems: "end",
              gap: "5px",
              width: "150px",
              margin: "3px 0px",
            }}
          >
            <IncomingEnvelop style={{ width: "25px", height: "25px" }} />
            <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>{customSummary.pendingIncoming}</Typography>
            <Typography style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}>
              {`${t(`${tRP}.incoming`)}`}
            </Typography>
          </Grid>
        )
      )}
    </Grid>
  );
};
export default PendingIncomingMailLink;
